import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../spinner/spinner.component';
import { PopupMessageComponent } from '../popup-message/popup-message.component';
import { TipsService } from '../../../shared/services/tips.service';

@Component({
  selector: 'history',
  standalone: true,
  imports: [
    CommonModule,
    SpinnerComponent,
    PopupMessageComponent
  ],
  templateUrl: './history.component.html',
  styleUrl: './history.component.css'
})
export class HistoryComponent implements OnInit {

  @Input() tipId: number | null = null;
  @Output() onClose = new EventEmitter<void>();

  logs: any[] = [];
  messageModal: string | null = null;
  popupMessage: string | null = null;
  loading: boolean = false;

  constructor(
      private tipsService: TipsService
  ) {}

  ngOnInit(): void {
    this.loadHistory();
  }

  loadHistory(): void {
    this.loading = true;
    if (this.tipId) {
      this.tipsService.getTipLogsByTipId(this.tipId).subscribe({
        next: (res) => {
          this.loading = false;
          console.log('Successfully retrieving history for case:', res);
          if (!res.has_error) {
            this.logs = res.payload;
          }
        },
        error: (err) => {
          this.loading = false;
          console.error(err);
          this.popupMessage = err.message
          this.messageModal = 'unsuccess';
        }
      });
    }
  }

  handleCloseHistory(): void {
    this.onClose.emit();
  }
  
  resetMessageModal(): void {
    this.messageModal = null;
    this.popupMessage = null;
    this.onClose.emit();
  }
}
